import { Charts } from './Charts';
import MortalityMorbityChartsDataProvider from './contexts/MortalityMobidityChartsDataContext';

const MortalityMorbityWrapper = () => {
    return (
        <MortalityMorbityChartsDataProvider>
            <Charts />
        </MortalityMorbityChartsDataProvider>
    );
};

export default MortalityMorbityWrapper;
